import { useDeleteOteConType } from "./api/deleteOteConType";
import { Button } from "reactstrap";


const DeleteOteConType = ({handleCloseModal, oteConTypeId}: DeleteOteConTypeProps)  => {
  
  const deleteOteConTypeMutation = useDeleteOteConType({ oteConTypeId});
  const handleSubmit = async (): Promise<void> => {
    deleteOteConTypeMutation.mutateAsync({ 
      oteConTypeId: oteConTypeId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Είδος γραμμής ΟΤΕ;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteOteConTypeProps{
  oteConTypeId: number;
  handleCloseModal: () => void;
}

export default DeleteOteConType;